<template>
    
    <div>    
       <!--  <p>Id ES {{$route.params.id}}</p> -->
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">Otros movimientos</li>
            </ol>
        </nav>
        <div>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body" style="display:flex; flex-wrap: wrap;">
                            <div style="width: 100%; display:flex; justify-content:center;">
                                <button type="button" class="boton-3d-success" @click=boton_modal_registro>
                                    Nuevo movimiento
                                </button>
                            </div>       
                            <div v-if="datos.data_table.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:white;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>     
                            <div id="contenedor-tabla-registros" style="width: 100%;">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <!-- inicio modal registro -->
        <div class="modal fade bd-example-modal-lg" id="modal-registro">
            <div class="modal-dialog modal-xl" style="width:90%;">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        
                        <h5>Otros movientos</h5>

                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">

                                <div class="form-group col-md-3">
                                    <label for="inputEmail4">Tipo:</label>                                    
                                    <select class="form-control input-3d" v-model=datos.registro.tipo>
                                        <option value="" disabled>Seleccione</option>
                                        <template v-if="general.verificacion_rol.otros_movimientos.option_ingreso">
                                            <option value="ingreso">Ingreso</option>
                                        </template>
                                        <option value="gasto">Gasto</option>
                                    </select>
                                </div> 
                                <div class="form-group col-md-3">
                                    <label for="inputEmail4">Cantidad:</label> 
                                    <input type="number" class="form-control input-3d" v-model=datos.registro.cantidad>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="inputEmail4">Descripción:</label> 
                                    <textarea rows="2" class="form-control input-3d" v-model=datos.registro.descripcion></textarea>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="inputEmail4">Fecha creación:</label> 
                                    <input type="date" class="form-control input-3d" v-model=datos.registro.fecha_creacion>
                                </div>

                                
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer">
                        
                        <button type="button" class="boton-3d-success" @click=enviar_datos>
                            Guardar
                        </button>
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">
                            Cerrar
                        </button>

                    </div>
                </div>
            </div>
        </div>
        <!---fin modal registro---->


    </div>

</template>

<script>
/* eslint-disable */
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'
//import { mapMutations } from 'vuex'

import * as calculos  from '@/librerias/lobato-calculos.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            registro_cargando:false,
            registro:{
                id:'',
                tipo:'',
                cantidad:'',
                descripcion:'',
                fecha_creacion:''
            },
            data_table:{
                cargando:false,
                registros:[]
            }
        }
    }
    },
    mounted(){
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        //...mapActions(['formato_moneda']),
        inicial()
        {
            if(this.general.otros.autenticado===true)
            {
                //this.obtener_recursos();
                this.data_table();
            }
            else if(this.general.otros.autenticado===false)
            {
                this.$router.push('/login');
            }
        },  
        obtener_recursos()
        {
            fetch(`${this.general.otros.dominio_server}/compras/recursos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('recursos');
                console.log(respuesta);
                this.datos.productos.todos  =respuesta.datos.productos;
                this.datos.clientes.todos   =respuesta.datos.clientes;

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },    
        boton_modal_registro()
        {
            for (const p in this.datos.registro) {                    
                                
                this.datos.registro[p]='';                
                
            }         
            
            let fechaActual = new Date();
            let ano = fechaActual.getFullYear();

            let mes = fechaActual.getMonth() + 1;
            mes=mes<10 ? `0${mes}` : mes;

            let dia = fechaActual.getDate();
            dia=dia<10 ? `0${dia}` : dia;

            let fecha = `${ano}-${mes}-${dia}`;
            this.datos.registro.fecha_creacion=fecha;

            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-registro").modal("show");
        },
        data_table()
        {
            this.datos.data_table.cargando=true;            
            fetch(`${this.general.otros.dominio_server}/otros_movimientos/todos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                this.datos.data_table.registros=respuesta.datos;                
                this.data_table_crear();
            })
            .catch(error=>{
                //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los clientes`});
            })
            .finally( () => {
                this.datos.data_table.cargando=false;                
            });
        },
        data_table_crear()
        {
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Tipo</th>
                            <th>Cantidad</th>
                            <th>Descripción</th>
                            <th>Fecha creación</th>
                            <th>Hora creación</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody >
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Id</th>
                            <th>Tipo</th>
                            <th>Cantidad</th>
                            <th>Descripción</th>
                            <th>Fecha creación</th>
                            <th>Hora creación</th>
                            <th>Acciones</th>
                        </tr>
                    </tfoot>
                </table>
            `;
            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
        
                $( 'input', this ).on( 'keyup change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
            } );
            
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[0,'desc'],
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`/clientes/todos`,
                data:this.datos.data_table.registros,                
                columnDefs:[
                    {"targets":0, "data":function(data,type,full,meta)
                        {
                            return data.id;
                        }
                    }, 
                    {"targets":1, "data":function(data,type,full,meta)
                        {                            
                            return data.tipo;
                        }
                    },                    
                    {"targets":2, "data":(data,type,full,meta)=>
                        {
                            return this.formato_moneda(data.cantidad);
                        }   
                    },
                    {"targets":3, "data":(data,type,full,meta)=>
                        {
                            return data.descripcion;                           
                        }   
                    },
                    {"targets":4, "data":(data,type,full,meta)=>
                        {
                            return data.fecha_creacion;                           
                        }   
                    },
                    {"targets":5, "data":(data,type,full,meta)=>
                        {
                            return data.hora_creacion;                           
                        }   
                    },
                    {"targets":6, "data":(data,type,full,meta)=>
                        {
                            var acciones=``;                            

                            acciones+=`
                                <button registro-id='${data.id}' class="boton-modal-editar-registro boton-3d-info" style="margin-right:1em;">                                    
                                    <i registro-id='${data.id}' class="fa fa-pencil-square-o" aria-hidden="true"></i>                                    
                                </button>
                                <button registro-id='${data.id}' class="boton-modal-remover boton-3d-danger" style="margin-right:1em;">
                                    <i registro-id='${data.id}' class='fa fa-times' aria-hidden='true'></i>                                    
                                </button>
                            `;

                            return `
                                <div style="display:flex; justify-content:left;">
                                    ${acciones} 
                                </div>
                            `;
                        }
                    }
                ],
                "drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {               
                this.eventos_data_table();
            } );
            
        },
        eventos_data_table()
        {
            Array.from(document.getElementsByClassName("boton-modal-editar-registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_evento);
            });

            Array.from(document.getElementsByClassName("boton-modal-remover")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_remover);
            });
            
            /* Array.from(document.getElementsByClassName("boton-modal-eliminar")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_eliminar);
            }); */
        },
        boton_modal_remover(item)
        {
            //this.datos.registro.i
            let dt={
                id:calculos.atributo(item,'registro-id')
            };
            Swal.fire({
                title: `¿ Remover movimiento id : ${dt.id} ?`,
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, remover ahora",
                cancelButtonText:'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) 
                {
                    this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                    fetch(`${this.general.otros.dominio_server}/otros_movimientos/registro/remover`,{
                        method:'POST',
                        body:JSON.stringify( {
                            id:dt.id,
                        } ),
                        headers:{                    
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                            'Content-Type'  :'application/json',
                            'Accept'        :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                        },
                        credentials: 'include',                   
                    })
                    .then(res=>res.json())
                    .then(respuesta=>{
                        let dt={
                            'bien':()=>{                        
                                this.data_table();
                                //$("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Movimiento removido`});
                            }
                        };

                        if(respuesta.mensaje in dt )
                        {
                            dt[respuesta.mensaje]();
                        }                
                    })
                    .catch(error=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`El movimiento no se pudo remover`});
                    })
                    .finally( () => {
                        //this.datos.data_table.cargando=false;
                    });
                }
            });
        },
        boton_modal_editar_registro_evento(item)
        {        
            this.boton_modal_registro();
            this.datos.registro.id=item.target.getAttribute('registro-id');  
            this.datos.registro_cargando=true;    
            this.datos.registro.fecha_creacion='';      
            //fetch(`${this.general.otros.dominio}/productos/${this.datos.registro.id}/datos`)
            fetch(`${this.general.otros.dominio_server}/otros_movimientos/${this.datos.registro.id}/datos`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{

                let m=respuesta.datos.movimiento[0];
                let r=this.datos.registro;

                r.tipo          =m.tipo;
                r.cantidad      =m.cantidad;
                r.descripcion   =m.descripcion;   
                r.fecha_creacion=m.fecha_creacion;             

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo obtener la información`});
            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
            
        },                
        agregar_producto(p)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.agregar});
            this.datos.registro.productos.push({
                id          :p==='' ? '' : p.id,
                productos_id:p==='' ? '' : p.productos_id,
                precio      :p==='' ? '' : p.precio,
                cantidad    :p==='' ? '' : p.cantidad,
                total       :p==='' ? '' : p.total,
                posicion    :'',
                estado      :'activo'
            });
            this.productos_ordenar_posiciones();
        },
        boton_remover_producto(index)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.remover});
            this.datos.registro.productos[index].estado='inactivo';
            this.productos_ordenar_posiciones();
            this.calcular_registro_venta_total();
        },
        productos_ordenar_posiciones()
        {            
            let a=0;
            this.datos.registro.productos.forEach((item,index)=>{
                
                if(item.estado=='activo')
                {
                    a++;
                    item.posicion=a;
                }

            });
        },

        ////////////////
        material_seleccionado(index)
        {
            /* let p=this.datos.registro.productos[index];
            let a=(this.datos.productos.todos).find((e)=>e.id==p.productos_id);
            p.precio=a===undefined ? 0 : a.precio;
            this.calcular_producto_total(index); */
        },
        calcular_producto_total(index)
        {
            let p=this.datos.registro.productos[index];
            p.total=calculos.calcular_multiplicacion([
                p.precio,
                p.cantidad
            ]);
            p.total=(p.total).toFixed(2);
            this.calcular_registro_venta_total();
        },
        calcular_registro_venta_total()
        {
            let r=this.datos.registro;
            r.total_venta=0;

            (r.productos).forEach((p,index)=>{

                if(p.estado=='activo')
                {                                    
                    r.total_venta=calculos.calcular_suma([
                        r.total_venta,
                        p.total
                    ]);
                }
            });
            console.log(this.datos.registro);
        },
        enviar_datos(a)
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
            
            //let p=this.datos.registro.productos.filter((e)=>e.estado=='activo' || (e.estado=='inactivo' && e.id!='') );
            
            fetch(`${this.general.otros.dominio_server}/otros_movimientos/registro`,{
                method:'POST',
                body:JSON.stringify( this.datos.registro ),
                headers:{                    
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        this.data_table();
                        $("#modal-registro").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Movimiento guardado`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`Los movimientos no se pudieron guardar`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });
        },
        formato_moneda(m)
        {
            m=calculos.revisar_numero(m);
            return (m).toLocaleString("es-MX",{
                style: 'currency',
                currency: 'MXN'
            });
        }     
    },
    computed: {
        ...mapState(['general']),
        /* ...mapGetters(['formatear_moneda']),
        formato_moneda(m)
        {
            this.formatear_moneda(m);
        } */
    },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>        
    .contenedor-producto{
        background:linear-gradient(90deg, #0093ff, #484848);
        border-radius:7px; 
        margin-bottom:1em; 
        padding:1em;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
        padding-bottom:0px; 
        padding-top:0.5em;

        /* &:hover{
            background:linear-gradient(90deg, #01253f, #1d1c1c);
        } */

        label {
            color:white;
        }
    }
</style>